<template>
  <div class="reset-password">
    <b-container class="p-0 pm-2">
      <b-card class="card-login pb-4">
        <img v-if="logoSrc" :src="getImgUrl(logoSrc)" class="d-block mx-auto" />
        <h2 v-if="titleH2" class="mt-3 mb-4" v-html="titleH2"></h2>
        <b-row>
          <b-col>
            <h6 v-if="welcomeHeader" class="welecomeH6" v-bind:class="{
          'welecomeMIDH6 mt-5': guard == 'MID',
          'welecomeDYH6 mt-1 text-center': guard == 'DY',
          'welecomeDoorderH6 mt-5': guard == 'DOORDER',
          'welecomeAVH6 mt-3 text-center': guard == 'AV',
          'welcomeGHH6 mt-3': guard == 'GARDENHELP',
          'welcomeCRiskH6 mt-3': guard == 'CRISK',
        }">
              {{ welcomeHeader }}
            </h6>
            <p v-if="welcomeSubheader" class="welcomeP" v-bind:class="{
          welecomeMIDP: guard == 'MID',
          'welecomeDYP mt-3': guard == 'DY',
          'welecomeDoorderP mb-3': guard == 'DOORDER',
          'welecomeAVP mt-3': guard == 'AV',
          'welcomeGHP mb-3': guard == 'GARDENHELP',
          'welcomeCRiskP mb-3': guard == 'CRISK',
        }">
              {{ welcomeSubheader }}
            </p>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group id="new-password-input-group"
                label-for="email">
                <b-form-input class="form-control-auth form-control-validate-password" v-bind:class="{
          'form-control-auth-mid': guard == 'MID',
          'form-control-auth-doom-yoga': guard == 'DY',
          'form-control-auth-doorder': guard == 'DOORDER',
          'form-control-auth-astrology': guard == 'AV',
          'form-control-auth-garden-help': guard == 'GARDENHELP',
        }" id="new-password" v-model="new_password" type="password" :placeholder="$t('new_password')"
                  required></b-form-input>
                <ul v-bind:class="{
          'password-validation-ul-garden-help': guard == 'GARDENHELP',
        }">
                  <li v-bind:class="{ is_valid: contains_eight_characters }">
                    {{ $t('validate_password_8_char') }}
                  </li>
                  <li v-bind:class="{ is_valid: contains_number }">
                    {{ $t('validate_password_num') }}
                  </li>
                  <li v-bind:class="{ is_valid: contains_uppercase }">
                    {{ $t('validate_password_uppercase') }}
                  </li>
                  <li v-bind:class="{ is_valid: contains_special_character }">
                    {{ $t('validate_password_special') }}
                  </li>
                </ul>
              </b-form-group></b-col></b-row>
          <b-row>
            <b-col>
              <b-form-group id="confirm-password-input-group" 
                label-for="email">
                <b-form-input class="
                      form-control-auth form-control-validate-confirm-password
                    " v-bind:class="{
          'form-control-auth-mid': guard == 'MID',
          'form-control-auth-doom-yoga': guard == 'DY',
          'form-control-auth-doorder': guard == 'DOORDER',
          'form-control-auth-astrology': guard == 'AV',
          'form-control-auth-garden-help': guard == 'GARDENHELP',
        }" id="confirm-password" v-model="confirm_password" type="password" :placeholder="$t('reenter_password')"
                  required></b-form-input>
                <ul v-bind:class="{
          'password-validation-ul-garden-help': guard == 'GARDENHELP',
        }">
                  <li v-bind:class="{ is_valid: match_passwords }">
                    {{ $t('validate_password_match') }}
                  </li>
                </ul>
              </b-form-group></b-col></b-row>
          <input type="hidden" name="guard" v-model="guard" />
          <input type="hidden" name="token" v-model="token" />
          <input type="hidden" name="email" v-model="email" />
          <div class="d-flex justify-content-center align-content-center mt-3" :class="{
          'submitButtonContainerGH mt-3': guard === 'GARDENHELP',
        }">
            <button class="btn" v-bind:class="{
          'btn-login-mid': guard === 'MID',
          'btn-login-dy': guard === 'DY',
          'btn-login-doorder': guard === 'DOORDER',
          'btn-login-av': guard === 'AV',
          'btn-login-garden-help': guard === 'GARDENHELP',
        }" type="submit" :disabled="!valid_password || !match_passwords">
              {{ $t('reset_password_title') }}
            </button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  props: [
    "titleH2",
    "logoSrc",
    "guard",
    "welcomeHeader",
    "welcomeSubheader",
    "clientLink",
    "token",
    "email",
  ],
  data() {
    return {
      code: "",
      new_password: "",
      confirm_password: "",
      client: this.guard,

      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      valid_password: false,
      match_passwords: false,
      swal_confirm_button_class: "",
      swal_container_class: "",
      user_type: null
    };
  },
  mounted() {
    this.user_type = this.$route.params.type;

    console.log(window.localStorage.getItem("user"));
    console.log(this.$route.query.token);
    this.code = window.sessionStorage.getItem("code");
    if (this.guard == "GARDENHELP") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-gardenhelp  btn-gardenhelp-primary";
      this.swal_container_class = "swal-container-garden-help";
    }
  },
  watch: {
    new_password(newval, oldval) {
      // console.log(newval, oldval)
      this.new_password_length = this.new_password.length;
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.new_password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.new_password);
      this.contains_uppercase = /[A-Z]/.test(this.new_password);
      this.contains_special_character = format.test(this.new_password);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    confirm_password(newval, oldval) {
      if (this.new_password != this.confirm_password) {
        this.match_passwords = false;
      } else {
        this.match_passwords = true;
      }
    },
  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      console.log(window.localStorage);
      console.log("login submit");
      console.log(this.$parent.$parent.isLogin);
      if (this.guard == 'GARDENHELP') {
        axios
          .post(
            `${this.user_type === 'customer' ? 'user' : 'operator'}/reset-password`,
            {
              code: this.code,
              password: this.new_password,
              password_confirmation: this.confirm_password,
              client: this.guard,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.guard,
              },
            }
          )
          .then((response) => {
            console.log(response);
            console.log(response.data);
            window.sessionStorage.removeItem("code");
            window.sessionStorage.removeItem("email");
            this.new_password = "";
            this.confirm_password = "";
            this.$fire({
              // title: "Title",
              text: this.$t('reset_password_success'),
              type: "success",
              // timer: 3000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
            document.body.classList.remove("swal2-height-auto");
          })
          .catch((error) => {
            console.log(error);
            this.new_password = "";
            this.confirm_password = "";
            this.$fire({
              // title: "Title",
              text: error,
              type: "error",
              // timer: 5000,
              customClass: {
                container: this.swal_container_class,
                confirmButton: this.swal_confirm_button_class,
              },
            }).then((r) => {
              // console.log(r.value);
            });
            document.body.classList.remove("swal2-height-auto");
          });
      }
     
    },
  },
};
</script>
<style scoped>
/* .is_valid:before { width: 100%; } */
</style>


// WEBPACK FOOTER //
// src/components/auth/ResetPassword.vue